import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/services/global.service';
@Injectable(
  { providedIn: 'root' }
)
export class SessionGuard implements CanActivate {
  constructor(private router: Router, private global: GlobalService) { }

  canActivate() {
    let token = localStorage.getItem(this.global.settings.ETRAPP_USER);
    
    if (token === null) {
      return true;
    }
    this.router.navigate(['/dashboard']);
    return false;
  }
}
